module.exports = __webpack_public_path__ + "img/bb_g1_t_ears-03.291c565f.svg";